import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface CreateContractorReviewDto {
  /**
   * format: int32
   * minimum: 0
   * maximum: 5
   */
  score: number;

  /**
   * minLength: 0
   * maxLength: 2000
   */
  comment?: string;

  scopeOfPractice: ScopeOfPracticeEnum;
}
